import { useEffect, useState } from 'react';
import { api, type ShopListItem } from '../api';
import { usePageMeta } from '../seo';
import { ProductCard } from '../storefront/ProductCard';

/**
 * Akční zboží – produkty ve slevě.
 *
 * Data (přeškrtnutá cena) už existují u variant; stránka je jen jejich výpis,
 * seřazený od největší slevy. Marketingová/SEO landing page bez nové tabulky.
 */
export function SalePage() {
  const [items, setItems] = useState<readonly ShopListItem[]>([]);
  const [loading, setLoading] = useState(true);

  usePageMeta({
    title: 'Akční zboží | Super Krmivo',
    description: 'Zlevněné krmivo a chovatelské potřeby. Ušetři na oblíbených značkách.',
  });

  useEffect(() => {
    let alive = true;
    api
      .specials()
      .then((result) => {
        if (alive) setItems(result.items);
      })
      .catch(() => {
        if (alive) setItems([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  if (loading) return <div className="page-loading" aria-hidden="true" />;

  return (
    <section className="block products">
      <div className="block-head">
        <h1 className="block-title">Akční zboží</h1>
        {items.length > 0 && <span className="muted small">{items.length} položek ve slevě</span>}
      </div>

      {items.length === 0 ? (
        <p className="empty muted">Právě teď nic ve slevě není. Mrkni zase příště.</p>
      ) : (
        <div className="grid">
          {items.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>
      )}
    </section>
  );
}
